import axios from "axios";
import dotEnv from "dotenv";
dotEnv.config();

const apiURL = process.env.REACT_APP_BASE_URL;
const oldApiURL = process.env.REACT_APP_OLD_BASE_URL || apiURL;
const urlImport = (data = {}, accessTokan) => {
  if (!data?.clonefromPdf) {
    return axios.post(
      `${apiURL}/urlImport`,
      {
        ...data,
      },
      {
        headers: {
          accept: "application/json",
          authorization: `bearer ${accessTokan}`,
        },
      }
    );
  } else {
    var formData = new FormData();
    formData.append("file", data.file);
    formData.append("clonefromPdf", data.clonefromPdf);
    formData.append("createOffer", data.createOffer);
    formData.append("propertyId", data.propertyId);
    formData.append("openFor", data.openFor);
    if (data.transactionData) {
      const transactionDataString = JSON.stringify(data.transactionData);
      formData.append("transactionData", transactionDataString);
    }
    const config = {
      method: "POST",
      url: `${oldApiURL}/offerImport`,
      headers: {
        accept: "application/json",
        "Content-Type": "multipart/form-data",
        authorization: `bearer ${accessTokan}`,
      },
      data: formData,
    };
    return axios(config);
  }
};

export const documentDataApi = {
  urlImport,
};
